import DocumentPreviewModal from './DocumentPreviewModal';

export default DocumentPreviewModal;
